import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// import Header from '../components/Header';
import Headstu from '../StudentLogin/Headstu';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import   "./Chat.css";
import {FaMobileAlt, FaEnvelope ,FaMapMarkerAlt  } from 'react-icons/fa';




const ContactForm = () => {
  return (
    // <div className="container ">
     <div className="container-fluid">
             <div className="row justify-content-center" style={{ marginTop: '6%' }}>
               
               {/* Left Section (Contact Info) */}
               <div
                 className="col-md-4 contact-left"
                 style={{
                   padding: '5%',
                   borderRadius: '1rem',
                   boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.15)',
                   animation: 'slideInLeft 1s ease-out',
                 }}
               >
                 <div className="contact-info">
                   <img
                     src="https://image.ibb.co/kUASdV/contact-image.png"
                     alt="Contact"
                     className="contact-image"
                   />
                   <h2>Contact Us</h2>
                   <p >We would love to hear from you!</p>
                 </div>
               </div>
       
               {/* Right Section (Contact Details) */}
               <div
                 className="col-md-6 contact-right"
                 style={{
                   padding: '5%',
                   borderRadius: '1rem',
                   boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.1)',
                   animation: 'slideInRight 1s ease-out',
                 }}
               >
                 <h2 className="text-center">Get in Touch</h2>
       
                 <div className="contact-cards">
                   {/* Address Card */}
                   <div
                     className="contact-card"
                     // onClick={() =>
                     //   window.open(
                     //     'https://www.google.com/maps?q=LIDER+Technology+Solutions+Ptd+Ltd,+No:+381,+TN+Road,+SP+Kovil+Street,+Thiruvottiyur,+Chennai-600019',
                     //     '_blank'
                     //   )
                     // }
                   >
             
                     <div className="card-text">
                     <FaMapMarkerAlt className="icon" />
                       <h5>Address</h5>
                       <p style={{marginLeft:"2%", color:" #ff9b00"}}>
                         LIDER Technology Solutions Ptd Ltd
                         No: 381, TN Road, SP Kovil Street,
                         Thiruvottiyur, Chennai-600019
                       </p>
                       <p style={{ marginLeft: "2%", color: " #ff9b00" }}>
                207, SERANGOON CENTRAL
                #10-186 , SINGAPORE - 550207 .
                </p>
                     </div>
                   </div>
       
                   {/* Phone Card */}
                   <div className="contact-card">
                     
                     <div className="card-text">
                     <FaMobileAlt className="card-icon" />
                       <h5>Phone</h5>
                       <p  > 
                      <a style={{marginLeft:"142%"}} href="tel:+6585005636">  +65&nbsp;85005636</a>
                       </p>
                       <p style={{marginLeft:"142%"}} >
                  <a  href="tel:+919840369993">  +91&nbsp;9840369993</a>
                </p>
                     </div>
                   </div>
       
                   {/* Email Card */}
                   <div className="contact-card">
                     
                     <div className="card-text">
                     <FaEnvelope className="card-icon" />
                       <h5>Email</h5>
                       <p>
                         <a style={{marginLeft:"73%"}} href="mailto:impulz.lms@gmail.com">impulz.lms@gmail.com</a>
                       </p>
                     </div>
                   </div>
                 </div>
               </div>
       
             </div>
           </div>
   

     
    // </div>
  );
};










const NewbatchPage = () => {
  return (
    <div>
      <Headstu />
      <div className="container-xl px-4 mt-4">
        {/* Rest of the code... */}
        {/* Add the content you want to show below the Header component */}
        <ContactForm />
      </div>
    </div>
  );
};


export default NewbatchPage;



